import MetricCard from "../../common/MetricCard";
import type { DeflectionsDashboardResponse } from "../../../types/deflections";

interface Props {
  kpis?: DeflectionsDashboardResponse["kpis"];
  previousKpis?: DeflectionsDashboardResponse["previousKpis"];
  days: number;
}

export default function DeflectionsKpiRow({ kpis, previousKpis, days }: Props) {
  const oi = kpis?.orderInsightCalls ?? 0;
  const dr = kpis?.digitalReceiptCalls ?? 0;
  const prevOi = previousKpis?.orderInsightCalls ?? 0;
  const prevDr = previousKpis?.digitalReceiptCalls ?? 0;
  const avgPerDay = days > 0 ? Math.round((oi + dr) / days) : 0;
  const prevAvgPerDay = days > 0 ? Math.round((prevOi + prevDr) / days) : 0;

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 md:gap-6">
      <MetricCard label="Order Insight Requests" value={oi} previousValue={prevOi} polarity="positive" />
      <MetricCard label="Digital Receipt Requests" value={dr} previousValue={prevDr} polarity="positive" />
      <MetricCard label="Avg Requests / Day" value={avgPerDay} previousValue={prevAvgPerDay} polarity="positive" />
    </div>
  );
}
